/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  DateTimeOffset: string;
  Decimal: string;
  Milliseconds: string;
  Seconds: string;
};

export enum Browser {
  Chrome = 'CHROME',
  Edge = 'EDGE',
  Safari = 'SAFARI',
  Firefox = 'FIREFOX',
  Ie = 'IE',
  Other = 'OTHER'
}





export enum HardwareFailure {
  Passed = 'PASSED',
  Generic = 'GENERIC',
  Camera = 'CAMERA',
  Microphone = 'MICROPHONE',
  Speaker = 'SPEAKER',
  Network = 'NETWORK'
}


export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly storeEpicAudioVideoTestResults: Scalars['Boolean'];
};


export type MutationStoreEpicAudioVideoTestResultsArgs = {
  sessionId: Scalars['String'];
  success: Scalars['Boolean'];
  browser: Browser;
  browserVersion?: Maybe<Scalars['String']>;
  oS: Os;
  oSVersion?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  hardwareFailures?: Maybe<ReadonlyArray<Maybe<HardwareFailure>>>;
  additionalFailureInfo?: Maybe<Scalars['String']>;
};

export enum Os {
  Windows = 'WINDOWS',
  Mac = 'MAC',
  Linux = 'LINUX',
  Android = 'ANDROID',
  Ios = 'IOS',
  Other = 'OTHER'
}

export type Query = {
  readonly __typename?: 'Query';
  readonly getAriaIngestionKey?: Maybe<Scalars['String']>;
};


export type StoreEpicAudioVideoTestResultsMutationVariables = Exact<{
  sessionId: Scalars['String'];
  success: Scalars['Boolean'];
  browser: Browser;
  browserVersion?: Maybe<Scalars['String']>;
  oS: Os;
  oSVersion?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  hardwareFailures?: Maybe<ReadonlyArray<Maybe<HardwareFailure>> | Maybe<HardwareFailure>>;
  additionalFailureInfo?: Maybe<Scalars['String']>;
}>;


export type StoreEpicAudioVideoTestResultsMutation = (
  { readonly __typename?: 'Mutation' }
  & Pick<Mutation, 'storeEpicAudioVideoTestResults'>
);

export type GetAriaIngestionKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAriaIngestionKeyQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getAriaIngestionKey'>
);


export const StoreEpicAudioVideoTestResultsDocument = gql`
    mutation StoreEpicAudioVideoTestResults($sessionId: String!, $success: Boolean!, $browser: Browser!, $browserVersion: String = null, $oS: Os!, $oSVersion: String = null, $device: String = null, $hardwareFailures: [HardwareFailure] = null, $additionalFailureInfo: String = null) {
  storeEpicAudioVideoTestResults(
    sessionId: $sessionId
    success: $success
    browser: $browser
    browserVersion: $browserVersion
    oS: $oS
    oSVersion: $oSVersion
    device: $device
    hardwareFailures: $hardwareFailures
    additionalFailureInfo: $additionalFailureInfo
  )
}
    `;
export type StoreEpicAudioVideoTestResultsMutationFn = ApolloReactCommon.MutationFunction<StoreEpicAudioVideoTestResultsMutation, StoreEpicAudioVideoTestResultsMutationVariables>;

/**
 * __useStoreEpicAudioVideoTestResultsMutation__
 *
 * To run a mutation, you first call `useStoreEpicAudioVideoTestResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreEpicAudioVideoTestResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeEpicAudioVideoTestResultsMutation, { data, loading, error }] = useStoreEpicAudioVideoTestResultsMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      success: // value for 'success'
 *      browser: // value for 'browser'
 *      browserVersion: // value for 'browserVersion'
 *      oS: // value for 'oS'
 *      oSVersion: // value for 'oSVersion'
 *      device: // value for 'device'
 *      hardwareFailures: // value for 'hardwareFailures'
 *      additionalFailureInfo: // value for 'additionalFailureInfo'
 *   },
 * });
 */
export function useStoreEpicAudioVideoTestResultsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StoreEpicAudioVideoTestResultsMutation, StoreEpicAudioVideoTestResultsMutationVariables>) {
        return ApolloReactHooks.useMutation<StoreEpicAudioVideoTestResultsMutation, StoreEpicAudioVideoTestResultsMutationVariables>(StoreEpicAudioVideoTestResultsDocument, baseOptions);
      }
export type StoreEpicAudioVideoTestResultsMutationHookResult = ReturnType<typeof useStoreEpicAudioVideoTestResultsMutation>;
export type StoreEpicAudioVideoTestResultsMutationResult = ApolloReactCommon.MutationResult<StoreEpicAudioVideoTestResultsMutation>;
export type StoreEpicAudioVideoTestResultsMutationOptions = ApolloReactCommon.BaseMutationOptions<StoreEpicAudioVideoTestResultsMutation, StoreEpicAudioVideoTestResultsMutationVariables>;
export const GetAriaIngestionKeyDocument = gql`
    query GetAriaIngestionKey {
  getAriaIngestionKey
}
    `;

/**
 * __useGetAriaIngestionKeyQuery__
 *
 * To run a query within a React component, call `useGetAriaIngestionKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAriaIngestionKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAriaIngestionKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAriaIngestionKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>(GetAriaIngestionKeyDocument, baseOptions);
      }
export function useGetAriaIngestionKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>(GetAriaIngestionKeyDocument, baseOptions);
        }
export type GetAriaIngestionKeyQueryHookResult = ReturnType<typeof useGetAriaIngestionKeyQuery>;
export type GetAriaIngestionKeyLazyQueryHookResult = ReturnType<typeof useGetAriaIngestionKeyLazyQuery>;
export type GetAriaIngestionKeyQueryResult = ApolloReactCommon.QueryResult<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>;